import * as React from "react";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

// Classes
import Utility from "../../domain/classes/Utility";

// NPM
import clsx from "clsx";

export const styles = (theme: Theme) =>
	createStyles({
		root: {
			borderRadius: 4,
			border: "1px solid #DFDFDF",
			width: "100%",
			margin: 0,
			padding: theme.spacing(2),
		},
		legend: {
			padding: theme.spacing(0, 1),
		},
	});

export interface FormattedFieldSetProps
	extends React.HTMLAttributes<HTMLFieldSetElement> {
	label: string;
	children: React.ReactNode;
}

const FormattedFieldSet = React.forwardRef<
	HTMLFieldSetElement,
	FormattedFieldSetProps & WithStyles<typeof styles>
>(({ classes, className, children, label }) => {
	return (
		<fieldset className={clsx(classes.root, className)}>
			<legend className={classes.legend}>
				<Typography variant="caption">{label}</Typography>
			</legend>
			{children}
		</fieldset>
	);
});

export default withStyles(styles, {
	name: Utility.generateClassName("FormattedFieldSet"),
})(FormattedFieldSet);
